import { BaseEntity } from 'yt-ng-framework';

export class ZbirniDnevnik extends BaseEntity {
    constructor(){
        super();
    }

    Datum: Date = null;
    Vrsta: string = null;
    UPs: number = 0;
    UUlDinSaRacuna: number = 0;
    UUlDinIsplNaBlagajni: number = 0;
    UIntUlSaDrBlagMesta: number = 0;
    UIntUlSaDrMenjMesta: number = 0;
    UIntUlUBlagPlatneUsluge: number = 0;
    UUkUplProdajaEfektive: number = 0;
    UUlDinSaBankomata: number = 0;
    UUlDinSaPrivrBlagMesta: number = 0;
    UUlDinOdPutMenjaca: number = 0;
    UUnpProdajaEfektive: number = 0;
    UUnpOtkupEfektive: number = 0;
    UUnpOtkupInValuta: number = 0;
    UUnpOtkupOsteceneEfektive: number = 0;
    UUnpOtkupVanoptEfektive: number = 0;
    UUnpZamenaOsteceneEfektive: number = 0;
    UUnpZamenaVanoptEfektive: number = 0;
    IIntIzNaDrBlagMesto: number = 0;
    IIntIzNaDrMenjMesto: number = 0;
    IIntIzPlatneUsluge: number = 0;
    IUkupnoOtkupEfektive: number = 0;
    IBankomat: number = 0;
    IPrivrBlagMesto: number = 0;
    IPutMenjacu: number = 0;
    IRadiKupovineEfektive: number = 0;
    IUplataNaTekRacun: number = 0;
    IIsknjizavanjeProvizije: number = 0;
    IKursneRazlike: number = 0;
    IUlDinPlatUsl: number = 0;
    IIzDinPlatUsl: number = 0;
    BrTrans: number = 0;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Datum = input.Datum;
        this.Vrsta = input.Vrsta;
        this.UPs = input.UPs;
        this.UUlDinSaRacuna = input.UUlDinSaRacuna;
        this.UUlDinIsplNaBlagajni = input.UUlDinIsplNaBlagajni;
        this.UIntUlSaDrBlagMesta = input.UIntUlSaDrBlagMesta;
        this.UIntUlSaDrMenjMesta = input.UIntUlSaDrMenjMesta;
        this.UIntUlUBlagPlatneUsluge = input.UIntUlUBlagPlatneUsluge;
        this.UUkUplProdajaEfektive = input.UUkUplProdajaEfektive;
        this.UUlDinSaBankomata = input.UUlDinSaBankomata;
        this.UUlDinSaPrivrBlagMesta = input.UUlDinSaPrivrBlagMesta;
        this.UUlDinOdPutMenjaca = input.UUlDinOdPutMenjaca;
        this.UUnpProdajaEfektive = input.UUnpProdajaEfektive;
        this.UUnpOtkupEfektive = input.UUnpOtkupEfektive;
        this.UUnpOtkupInValuta = input.UUnpOtkupInValuta;
        this.UUnpOtkupOsteceneEfektive = input.UUnpOtkupOsteceneEfektive;
        this.UUnpOtkupVanoptEfektive = input.UUnpOtkupVanoptEfektive;
        this.UUnpZamenaOsteceneEfektive = input.UUnpZamenaOsteceneEfektive;
        this.UUnpZamenaVanoptEfektive = input.UUnpZamenaVanoptEfektive;
        this.IIntIzNaDrBlagMesto = input.IIntIzNaDrBlagMesto;
        this.IIntIzNaDrMenjMesto = input.IIntIzNaDrMenjMesto;
        this.IIntIzPlatneUsluge = input.IIntIzPlatneUsluge;
        this.IUkupnoOtkupEfektive = input.IUkupnoOtkupEfektive;
        this.IBankomat = input.IBankomat;
        this.IPrivrBlagMesto = input.IPrivrBlagMesto;
        this.IPutMenjacu = input.IPutMenjacu;
        this.IRadiKupovineEfektive = input.IRadiKupovineEfektive;
        this.IUplataNaTekRacun = input.IUplataNaTekRacun;
        this.IIsknjizavanjeProvizije = input.IIsknjizavanjeProvizije;
        this.IKursneRazlike = input.IKursneRazlike;
        this.IUlDinPlatUsl = input.IUlDinPlatUsl;
        this.IIzDinPlatUsl = input.IIzDinPlatUsl;
        this.BrTrans = input.BrTrans;
        return this;
    }

    Serialize(input: ZbirniDnevnik){
        return input;
    }
}
